/**
 * GET/PUT/POST /api/mail-templates — stored defaults for invitation and document-review mail.
 */
import { API_BASE_URL } from '../config';

export type MailTemplateKeyApi =
  | 'INVITATION'
  | 'RESUBMISSION_REQUEST'
  | 'APPROVAL_NOTICE'
  | 'SUBMISSION_COMPLETE';

export interface MailTemplateDto {
  templateKey: string;
  subject: string;
  body: string;
  updatedAt?: string | null;
}

export async function fetchAllMailTemplates(): Promise<MailTemplateDto[]> {
  const res = await fetch(`${API_BASE_URL}/api/mail-templates`);
  if (!res.ok) throw new Error('メールテンプレートの取得に失敗しました。');
  return res.json();
}

export async function fetchMailTemplate(key: MailTemplateKeyApi): Promise<MailTemplateDto> {
  const res = await fetch(`${API_BASE_URL}/api/mail-templates/${encodeURIComponent(key)}`);
  if (!res.ok) throw new Error('メールテンプレートの取得に失敗しました。');
  return res.json();
}

export async function updateMailTemplate(
  key: MailTemplateKeyApi,
  payload: { subject: string; body: string }
): Promise<MailTemplateDto> {
  const res = await fetch(`${API_BASE_URL}/api/mail-templates/${encodeURIComponent(key)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('保存に失敗しました。');
  return res.json();
}

export async function resetMailTemplate(key: MailTemplateKeyApi): Promise<MailTemplateDto> {
  const res = await fetch(`${API_BASE_URL}/api/mail-templates/${encodeURIComponent(key)}/reset`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error('デフォルトへの復元に失敗しました。');
  return res.json();
}
